<template>
  <footer>
    <div class="normal-text-bold" @click="openedTerms = 'privacy'">{{ __('privacy_policy') }}</div>
    <div class="normal-text-bold" @click="openedTerms = 'T&C'">{{ __('terms_and_conditions') }}</div>
    <div class="normal-text">{{ __('copyright') }}: Nordic Dental, {{ new Date().getFullYear() }}.</div>
  </footer>

  <div class="modal-background" v-if="openedTerms && legalText[openedTerms]">
    <div class="modal-content full-width" v-click-outside="closeTerms">
      <div class="modal-content-header">
        <p class="list-text-bold">
          {{ __(legalText[openedTerms].title) }}
        </p>
        <div class="modal-close" @click="closeTerms()">
          <div class="x-icon"></div>
        </div>
      </div>
      <div class="modal-content-legal" v-html="__(legalText[openedTerms].content)"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import __ from '@/translate';

const openedTerms = ref<keyof typeof legalText | null>(null);

const legalText = {
  privacy: {
    title: 'privacy_policy_title',
    content: 'privacy_policy_content',
  },
  'T&C': {
    title: 'terms_and_conditions_title',
    content: 'terms_and_conditions_content',
  },
};

function closeTerms() {
  openedTerms.value = null;
}
</script>
